interface Props {
  [key: string]: any
}

export default function PictureIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 14" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M18.3333 0H1.66667C0.746667 0.00108333 0.00108333 0.746667 0 1.66667V12.3333C0.00108333 13.2533 0.746667 13.9989 1.66667 14H18.3333C18.4269 14.0004 18.5203 13.9922 18.6123 13.9757C19.4144 13.8414 20.0015 13.1465 20 12.3333V1.66667C19.9989 0.746625 19.2533 0.00108333 18.3333 0ZM1.66667 13.3333C1.14854 13.3333 0.71625 12.9375 0.670667 12.4213L7.31667 8.076L14.0753 13.3333H1.66667ZM19.3333 12.3333C19.3339 12.8226 18.9795 13.24 18.4967 13.319C18.4427 13.3287 18.3881 13.3335 18.3333 13.3333H15.161L10.7447 9.89633L14.694 6.73833L19.3333 9.522V12.3333ZM19.3333 8.74467L14.8383 6.04767C14.7188 5.97579 14.5672 5.98592 14.4583 6.073L10.2027 9.47633L7.53767 7.40367C7.42537 7.31642 7.27012 7.30996 7.151 7.38767L0.666667 11.6273V1.66667C0.666667 1.11438 1.11437 0.666667 1.66667 0.666667H18.3333C18.8856 0.666667 19.3333 1.11438 19.3333 1.66667V8.74467Z"
        fill="currentColor"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M10 2C8.89542 2 8 2.89542 8 4C8.00108 5.10413 8.89588 5.99892 10 6C11.1046 6 12 5.10458 12 4C12 2.89542 11.1046 2 10 2ZM10 5.33333C9.26363 5.33333 8.66667 4.73638 8.66667 4C8.66667 3.26363 9.26363 2.66667 10 2.66667C10.7364 2.66667 11.3333 3.26363 11.3333 4C11.3333 4.73638 10.7364 5.33333 10 5.33333Z"
        fill="currentColor"
      />
    </svg>
  )
}
